export class ProductHashTagView {
    public productHashTagId: string;
    public hashTagId: string;
    public hashTagName: string;
    public displaySequence: number;
    public param: boolean;
}